const getBranchesAPI = () => 'api/branches';

const getRolesAPI = () => 'api/roles';

const getAlertsAPI = () => 'api/alerts';

const toggleAlertAPI = () => 'api/alerts';

const getServerTimeAPI = () => 'api/system/server-time';

const setServerTimeAPI = () => 'api/system/server-time';

const getImportProgressAPI = () => 'api/system/import-progress';

const getCompanySubscriptionAPI = () => 'api/platform/subscription/details';

export const appEndpoints = {
  getBranchesAPI,
  getRolesAPI,
  getAlertsAPI,
  toggleAlertAPI,
  getServerTimeAPI,
  setServerTimeAPI,
  getImportProgressAPI,
  getCompanySubscriptionAPI: getCompanySubscriptionAPI,
};
